// node-modules
import * as Swiper from 'swiper/dist/js/swiper';

// assets
import 'swiper/dist/css/swiper.min.css';
import './swiperSlider.scss';

const sliderOptions = {
  grabCursor: true,
  initialSlide: 0,
  speed: 1000,
  lazy: {
    loadPrevNext: true,
    loadPrevNextAmount: 2,
  },
  keyboard: true,
};

export function offersSlider(sliderContainer) {
  return new Swiper(sliderContainer.querySelector('[data-role="slider-container"]'), {
    ...sliderOptions,
    slidesPerView: 1,
    spaceBetween: 32,
    effect: 'slide',
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
}

export function servicesSlider(sliderContainer) {
  return new Swiper(sliderContainer.querySelector('[data-role="slider-container"]'), {
    ...sliderOptions,
    slidesPerView: 2,
    spaceBetween: 32,
    effect: 'slide',
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      767: {
        slidesPerView: 1.6,
        spaceBetween: 32,
      },
      640: {
        slidesPerView: 1.2,
        spaceBetween: 16,
      },
    },
  });
}

export function beforeAfterSlider(sliderContainer) {
  return new Swiper(sliderContainer.querySelector('[data-role="slider-container"]'), {
    ...sliderOptions,
    slidesPerView: 1,
    spaceBetween: 16,
    effect: 'fade',
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'fraction',
    },
  });
}

export function productSlider() {
  const galleryThumbs = new Swiper('[data-role="slider-thumbs"]', {
    spaceBetween: 16,
    slidesPerView: 2.3,
    freeMode: true,
    direction: 'horizontal',
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    breakpoints: {
      1023: {
        slidesPerView: 2.6,
      },
    },
  });
  const productTop = new Swiper('[data-role="slider-with-product"]', {
    spaceBetween: 10,
    effect: 'fade',
    thumbs: {
      swiper: galleryThumbs,
    },
  });
}
